import React from "react";
import { Link, NavLink } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./TrainingRequest.css";

function TrainingRequest({
  id,
  trainingName,
  trainingName_english,
  groupName,
  groupName_english,
  language,
  status,
  created_at,
  requester,
  requesterName,
  requesterBoss,
  role,
  userId,
}) {
  const { t } = useTranslation();

  const dayjs = require("dayjs");

  const selectColor = (status) => {
    if (status === "approved") {
      return (
        <span className="training-request-approved">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.Aprobado")}
        </span>
      );
    } else if (status === "pending") {
      return (
        <span className="training-request-pending">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.Pendiente")}
        </span>
      );
    } else if (status === "rejected") {
      return (
        <span className="training-request-rejected">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.Rechazado")}
        </span>
      );
    } else if (status === "hrApproved") {
      return (
        <span className="training-request-half-approved">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.AprobadoRH")}
        </span>
      );
    } else if (status === "bossApproved") {
      return (
        <span className="training-request-half-approved">
          {t("Capacitaciones.SolicitudesCapacitacion.Estado.AprobadoJefe")}
        </span>
      );
    }
  };

  const generateDropdownMenu = (role, status, requester, userId) => {
    if (role === "admin") {
      if (status === "pending") {
        return (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faCog} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={`/trainings/request/edit/${id}`}>
                <FontAwesomeIcon icon={faEdit} />{" "}
                {t("Capacitaciones.Capacitacion.Editar")}
              </Dropdown.Item>
              {requester.toString() === userId.toString() ? (
                <Dropdown.Item as={Link} to={`/trainings/request/delete/${id}`}>
                  <FontAwesomeIcon icon={faTrash} />{" "}
                  {t("Capacitaciones.Capacitacion.Eliminar")}
                </Dropdown.Item>
              ) : (
                <></>
              )}
            </Dropdown.Menu>
          </Dropdown>
        );
      }
    } else if (role === "root") {
      return (
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={`/trainings/request/edit/${id}`}>
              <FontAwesomeIcon icon={faEdit} />{" "}
              {t("Capacitaciones.Capacitacion.Editar")}
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={`/trainings/request/delete/${id}`}>
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Capacitaciones.Capacitacion.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else {
      if (requester.toString() === userId.toString()) {
        if (status === "pending") {
          return (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faCog} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/trainings/request/edit/${id}`}>
                  <FontAwesomeIcon icon={faEdit} />{" "}
                  {t("Capacitaciones.Capacitacion.Editar")}
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={`/trainings/request/delete/${id}`}>
                  <FontAwesomeIcon icon={faTrash} />{" "}
                  {t("Capacitaciones.Capacitacion.Eliminar")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        } else {
          return <></>;
        }
      } else if (requesterBoss.toString() === userId.toString()) {
        return <></>;
      }
    }
  };

  return (
    <Row className="training-request align-items-center">
      <Col lg={4} className="training-request-header">
        <NavLink className="nav-link" to={`/trainings/request/details/${id}`}>
          <h5>{language === "es" ? trainingName : trainingName_english}</h5>
        </NavLink>
        <p>{language === "es" ? groupName : groupName_english}</p>
      </Col>
      <Col lg={3}>
        <p>{requesterName}</p>
      </Col>
      <Col lg={2}>
        <p>{dayjs(created_at).format("DD-MM-YYYY")}</p>
      </Col>
      <Col lg={2}>{selectColor(status)}</Col>
      <Col lg={1} className="training-request-options">
        {generateDropdownMenu(role, status, requester, userId)}
      </Col>
    </Row>
  );
}

export default TrainingRequest;
